
import { get } from 'vuex-pathify'

export default {
  computed: {
    valid: get('delivery/validPostalCode'),
    postal: get('delivery/postalCode'),
    text() {
      return this.postal && !this.valid
        ? this.$t('delivery.invalidPostal')
        : this.$t('delivery.missingPostal')
    },
    type() {
      return this.postal && !this.valid
        ? 'danger'
        : 'warning'
    },
  }
}
